@if (treeNodes$ | async; as treeNodes) {
  <p-floatlabel variant="in">
    <p-treeSelect
      [options]="treeNodes"
      [(ngModel)]="selectedItem"
      (ngModelChange)="onSelectedChange($event)"
      selectionMode="checkbox"
      [virtualScroll]="true"
      [virtualScrollItemSize]="35"
      [virtualScrollOptions]="{ scrollHeight: '390px' }"
      display="chip"
      [style]="{ width: '100%', border: 'none' }"
    ></p-treeSelect>
    <label>
      {{ 'IP_JOURNAL_COPY_EDITOR.STRUCTURE_CHOOSE_TITLE' | transloco }}
      <ion-text color="danger">&nbsp;*</ion-text>
    </label>
  </p-floatlabel>
}
